import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import authOnEnter from 'enrollment-platform/authOnEnter'
import PageWrapper from 'enrollment-platform/PageWrapper'
import SharePoint from './SharePoint'
import { SHAREPOINT } from './paths'

const SharePointRoute = {
  path: SHAREPOINT,
  component: PageWrapper,
  onEnter(
    _nextState: unknown,
    _replace: unknown,
    callback: (err?: unknown) => void
  ) {
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN],
      callback,
    })
  },
  indexRoute: {
    component: SharePoint,
  },
}

export default SharePointRoute
